const baseURL = process.env.REACT_APP_BASE_URL;
const distanceMatrixAPIEndpoint =
  process.env.REACT_APP_DISTANCE_MATRIX_API_ENDPOINT;
const distanceMatrixAPIKey = process.env.REACT_APP_DISTANCE_MATRIX_API_KEY;
const mapquestAPIEndpoint = process.env.REACT_APP_MAPQUEST_API_ENDPOINT;
const mapquestAPIKey = process.env.REACT_APP_MAPQUEST_API_KEY;
const geocodingAPIBaseURL = process.env.REACT_APP_GEOCODING_API_BASE_URL;
const weatherAPIBaseURL = process.env.REACT_APP_WEATHER_API_BASE_URL;
const weatherAPIKey = process.env.REACT_APP_WEATHER_API_KEY;

export {
  baseURL,
  distanceMatrixAPIEndpoint,
  distanceMatrixAPIKey,
  mapquestAPIEndpoint,
  mapquestAPIKey,
  geocodingAPIBaseURL,
  weatherAPIBaseURL,
  weatherAPIKey,
};
